import { useMemo, useState } from 'react';
import { LinearProgress } from '@mui/material';
import clsx from 'clsx';
import { EXPORT_MODE_STYLES } from 'common/types/pdfExport/constants';
import { GridSkeleton } from 'components/Grid';
import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { useLayoutContext } from 'context/LayoutContext';
import { getNumberValue, getObjectValue } from 'utilities';
import { CustomScalarSpreadsheetProps } from './CustomScalarSpreadsheet.props';
import { classes, GridSkeletonRoot, Root } from './CustomScalarSpreadsheet.styles';

const CustomScalarSpreadsheet = (props: CustomScalarSpreadsheetProps) => {
  const { isLoading = false, isSaving = false, ...spreadsheetProps } = props;
  const { columns, rowConfig } = getObjectValue(spreadsheetProps);

  const columnsCount = getNumberValue(columns?.length) + 1;
  const rowConfigCount = getNumberValue(rowConfig?.length);

  const [isDisplayingToolbar, setIsDisplayingToolbar] = useState(false);
  const [spreadsheetWidth, setSpreadsheetWidth] = useState(0);
  const { isExportMode } = useLayoutContext();

  const scalarSpreadsheetProps = useMemo(() => {
    if (spreadsheetProps) {
      return {
        ...spreadsheetProps,
        setIsDisplayingToolbar,
        setSpreadsheetWidth,
      } as unknown as typeof ScalarSpreadsheet;
    }

    return null;
  }, [spreadsheetProps]);

  if (isSaving) {
    return (
      <GridSkeletonRoot spreadsheetWidth={spreadsheetWidth}>
        <GridSkeleton maxColumns={columnsCount} maxRows={rowConfigCount} />
      </GridSkeletonRoot>
    );
  }

  return (
    <Root isDisplayingToolbar={isDisplayingToolbar} spreadsheetWidth={spreadsheetWidth} style={isExportMode ? EXPORT_MODE_STYLES : {}}>
      <LinearProgress color="primary" className={clsx(classes.loading, { active: isLoading })} />
      {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
      {/* @ts-ignore: ScalarSpreadsheet is not typed */}
      <ScalarSpreadsheet {...scalarSpreadsheetProps} />
    </Root>
  );
};

export default CustomScalarSpreadsheet;
